import Vue from 'vue'
import VueRouter from 'vue-router'
import Menu from '../views/Menu.vue'
import About from '../views/About.vue'
import Contacto from '../views/Contacto.vue'
import Factura from '../views/Factura.vue'
import Retencion from '../views/Retencion.vue'
import NotaCredito from '../views/NotaCredito.vue'
import NotaDebito from '../views/NotaDebito.vue'
import LiquidacionCompra from '../views/LiquidacionCompra.vue'
import Guia from '../views/Guia.vue'
import Empresa from '../views/Empresa.vue'
import Electronico from '../views/Electronico.vue'
import Pendiente from '../views/Pendiente.vue'
import Parametro from '../views/Parametro.vue'
import Suscripcion from '../views/Suscripcion.vue'
import Certificado from '../views/Certificado.vue'
import Salir from '../views/Salir.vue'
import Login from '../views/Login.vue'
import ServidorCorreo from '../views/ServidorCorreo.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/menu',
    name: 'menu',
    component: Menu
  },
  {
    path: '/factura',
    name: 'factura',
    component: Factura
  },
  {
    path: '/retencion',
    name: 'retencion',
    component: Retencion
  },
  {
    path: '/notacredito',
    name: 'notacredito',
    component: NotaCredito
  },
  {
    path: '/notadebito',
    name: 'notadebito',
    component: NotaDebito
  },
  {
    path: '/liquidacioncompra',
    name: 'liquidacioncompra',
    component: LiquidacionCompra
  },
  {
    path: '/guia',
    name: 'guia',
    component: Guia
  },
  {
    path: '/empresa',
    name: 'empresa',
    component: Empresa
  },
  {
    path: '/parametro',
    name: 'parametro',
    component: Parametro
  },
  {
    path: '/suscripcion',
    name: 'suscripcion',
    component: Suscripcion
  },
  {
    path: '/pendiente',
    name: 'pendiente',
    component: Pendiente
  },
  {
    path: '/contacto',
    name: 'contacto',
    component: Contacto
  },
  {
    path: '/electronico',
    name: 'electronico',
    component: Electronico
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/servidor_correo',
    name: 'Servidor Correo',
    component: ServidorCorreo
  },
  {
    path: '/certificado',
    name: 'Certificado',
    component: Certificado
  },
  {
    path: '/salir',
    name: 'Salir',
    component: Salir
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
